<template>
  <div>
    <div v-if="!dataReady" class="pt-5 pb-5 text-center">
      <LeafPulse v-if="useCannabisSpinner" />
      <b-spinner v-else style="width: 3rem; height: 3rem" variant="success" />
    </div>
    <div v-if="dataReady">
      <div v-if="product && selectedBatch">
        <ProductSection
          :hide-prices="hidePrices"
          :hide-quantities="hideQuantities"
          :product="product"
          :selected-product="product"
          :selected-batch="selectedBatch"
          @contact-button-clicked="$emit('contactButtonClicked')"
        />
        <BatchSection
          :selected-batch="selectedBatch"
          :batches="batches"
          :cart-items="cartItems"
          :product="product"
          :disable-add="disableAdd"
          :user="user"
          :store-component-enabled="storeComponentEnabled"
          :bulk-discounts="bulkDiscounts"
          :hide-prices="hidePrices"
          :hide-quantities="hideQuantities"
          :cart-needs-to-be-chosen="cartNeedsToBeChosen"
          :active-location="activeLocation"
          @added-product="(product) => $emit('addedProduct', product)"
          @set-selected-batch="setSelectedBatch"
          @launch-p-t-o-modal="(val) => $emit('launchPTOModal', val)"
          @contact-button-clicked="$emit('contactButtonClicked')"
        />
      </div>
      <div v-else>
        <h5 class="text-center font-weight-bold text-nowrap text-medium">Product Not Found</h5>
      </div>
    </div>
  </div>
</template>
<script>
import BSpinner from "@/components/base/BSpinner.vue";
import LeafPulse from "@/components/common/loaders/LeafPulse.vue";

import ProductSection from "./productSection/ProductSection.vue";
import BatchSection from "./batchSection/BatchSection.vue";
import * as api from "@/services/api";
import { userCan } from "@/services/helpers";

export default {
  components: {
    BSpinner,
    ProductSection,
    BatchSection,
    LeafPulse,
  },
  props: {
    cartItems: {
      type: Array,
      default() {
        return [];
      },
    },
    buyerId: { type: Number },
    orderId: { type: Number },
    onMarketplace: { type: Boolean, default: false },
    user: { type: Object, default: null },
    selectedBatchId: { type: Number, default: null },
    storeComponentEnabled: { type: Boolean, default: true },
    bulkDiscounts: { type: Array, default: () => [] },
    hidePrices: { type: Boolean, default: false },
    hideQuantities: { type: Boolean, default: false },
    disableAdd: { type: Boolean, default: false },
    useCannabisSpinner: { type: Boolean, default: true },
    cartNeedsToBeChosen: { type: Boolean, default: false },
    activeLocation: { type: Object },
    selectedProduct: { type: Object, default: null },
  },
  emits: ["addedProduct", "contactButtonClicked", "launchPTOModal"],
  data() {
    return {
      product: this.selectedProduct,
      dataReady: false,
      selectedBatch: {},
      batches: [],
    };
  },
  computed: {},
  watch: {
    selectedProduct(val, oldVal) {
      if (val != oldVal) {
        this.setProduct();
      }
    },
  },
  mounted() {
    this.setProduct();
  },

  methods: {
    userCan,
    setupBatches() {
      const availableBatches = [];

      this.product.batches.forEach((element, index) => {
        if (!element.archived && !element.true_hold) {
          if (
            !element.restricted ||
            (this.user && this.userCan("sell restricted inventory", this.user) && this.user.current_company_id == this.product.company_id)
          ) {
            availableBatches.push({ ...element });
          }
        }
      });

      this.batches = availableBatches;
      this.initSelectedBatch(availableBatches);
    },
    setProduct() {
      let url = `/storefront/pdp/${this.product.id}`;
      if (this.orderId) {
        url = `${url}?orderId=${this.orderId}`;
      }
      if (this.onMarketplace) {
        if (url.includes("?")) {
          url = `${url}&onMarketplace=true`;
        } else {
          url = `${url}?onMarketplace=true`;
        }
      }
      if (this.buyerId) {
        if (url.includes("?")) {
          url = `${url}&buyerId=${this.buyerId}`;
        } else {
          url = `${url}?buyerId=${this.buyerId}`;
        }
      }

      api.get(url).then(
        (response) => {
          this.dataReady = true;
          if (response.data && response.data.data) {
            this.product = response.data.data;
            this.setupBatches();
          } else {
            //
          }
        },
        (error) => {
          //
        },
      );
    },
    initSelectedBatch(batches) {
      let initialBatch = null;
      if (this.selectedBatchId) {
        initialBatch = batches.find(({ id }) => id === this.selectedBatchId);
      }

      if (initialBatch && initialBatch.id) {
        this.setSelectedBatch(initialBatch);
      } else if (batches.length) {
        this.setSelectedBatch(batches[0]);
      } else {
        this.setSelectedBatch({});
      }
    },
    setSelectedBatch(batch) {
      this.selectedBatch = batch;
    },
  },
};
</script>
